export const NODE_CARD_ATTRIBUTE = 'data-node-card';
export const TRIGGER_ID_ATTRIBUTE = 'data-trigger-id';

export const nodeCardAttributes = { [NODE_CARD_ATTRIBUTE]: '' };

export const triggerIdAttributes = (triggerShortId: string) => {
  return { [TRIGGER_ID_ATTRIBUTE]: triggerShortId };
};
